import { Component, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal-confirmacion',
  imports: [FormsModule],
  templateUrl: './modal-confirmacion.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-confirmacion.css',
})
export class ModalConfirmacion {
  mensaje = input('');
  textoCancel = input('');
  textoConfirm = input('');

  cancelar = output<void>();
  confirmar = output<string | undefined>();

  showInput = input(false);
  loading = input(false);

  valorInput = model('');
  // metodos
  onCancel() {
    this.cancelar.emit();
  }
  onConfirm() {
    this.confirmar.emit(this.showInput() ? this.valorInput() : undefined);
  }
}
